var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,{tag:"component",staticClass:"item",attrs:{"to":_vm.to},on:{"click":_vm.onClick}},[_c('app-icon',{staticClass:"item-icon",attrs:{"icon":_vm.icon}}),_c('div',{staticClass:"item-text"},[_vm._v(_vm._s(_vm.text))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }